module.exports = __webpack_public_path__ + "static/media/ic-logo-super-cle-a-num.8dc0d1cb.png";